import type { Notification } from '@parlay-picker/shared/notification';
import type { NotificationDisplayData } from '@parlay-picker/shared/notificationDisplay';
import { Check, ChevronRight, X } from 'lucide-react';
import type { ReactElement } from 'react';

/** Footer: navigation link + action buttons */
export function CardFooter({
  notification,
  displayData,
  onMarkAsRead,
  onDismiss,
  onNavigateToParlay,
  compact,
}: {
  notification: Notification;
  displayData: NotificationDisplayData;
  onMarkAsRead: (ids: string[]) => Promise<void>;
  onDismiss: (id: string) => Promise<void>;
  onNavigateToParlay?: (parlayId: number) => void;
  compact?: boolean;
}): ReactElement {
  const isUnread = !notification.readAt;
  const showNav = displayData.hasNavigation && onNavigateToParlay && !compact;

  return (
    <div className="flex items-center justify-between mt-2 pt-1">
      {showNav ? (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            if (displayData.parlayId != null) onNavigateToParlay(displayData.parlayId);
          }}
          className="flex items-center gap-1 text-xs text-theme-primary hover:text-theme-primary-hover font-medium transition-colors min-h-8"
        >
          View Parlay <ChevronRight className="w-3 h-3" />
        </button>
      ) : (
        <div />
      )}
      <div className="flex items-center gap-1">
        {isUnread && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onMarkAsRead([notification.id]);
            }}
            className="p-1 rounded hover:bg-theme-surface-hover text-theme-text-tertiary hover:text-theme-text transition-colors min-h-8 min-w-8 flex items-center justify-center"
            title="Mark as read"
          >
            <Check className="w-3.5 h-3.5" />
          </button>
        )}
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss(notification.id);
          }}
          className="p-1 rounded hover:bg-theme-surface-hover text-theme-text-tertiary hover:text-theme-danger transition-colors min-h-8 min-w-8 flex items-center justify-center"
          title="Dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
